<!-- ICON SECTION (SUCCESS / ERROR / WARNING) -->
<div fxLayout="column">
    <div fxLayout="row wrap">
      <div fxLayout="row" fxFlex.xs="100" fxFlex.gt-xs="25" fxLayoutAlign="center center"></div>
  
      <div fxLayout="row" fxFlex.xs="100" fxFlex.gt-xs="70" fxFlex.gt-sm="50" fxLayoutAlign="center center">
        
        <!-- SUCCESS ICON -->
        <div class="svg-box" *ngIf="alertData.alertType === 'SUCCESS'">
          <svg class="circular green-stroke">
            <circle class="path" cx="75" cy="75" r="50" fill="none" stroke-width="5" stroke-miterlimit="10" />
          </svg>
          <svg class="checkmark green-stroke">
            <g transform="matrix(0.79961,0,0,0.79961,-489.57,-205.679)">
              <path class="checkmark__check" fill="none" d="M616.306,283.025L634.087,300.805L673.361,261.53" />
            </g>
          </svg>
        </div>
  
        <!-- ERROR ICON -->
        <div class="svg-box" *ngIf="alertData.alertType === 'ERROR'">
          <svg class="circular red-stroke">
            <circle class="path" cx="75" cy="75" r="50" fill="none" stroke-width="5" stroke-miterlimit="10" />
          </svg>
          <svg class="cross red-stroke">
            <g transform="matrix(0.79961,0,0,0.79961,-502.652,-204.518)">
              <path class="first-line" d="M634.087,300.805L673.361,261.53" fill="none" />
            </g>
            <g transform="matrix(-0.79961,0,0,0.79961,-204.752,543.031)">
              <path class="second-line" d="M634.087,300.805L673.361,261.53" />
            </g>
          </svg>
        </div>
  
        <!-- WARNING ICON -->
        <div class="svg-box" *ngIf="alertData.alertType === 'WARNING'">
          <svg class="circular yellow-stroke">
            <circle class="path" cx="75" cy="75" r="50" fill="none" stroke-width="5" stroke-miterlimit="10" />
          </svg>
          <svg class="alert-sign yellow-stroke">
            <g transform="matrix(1,0,0,1,-615.516,-257.346)">
              <g transform="matrix(0.56541,-0.56541,0.56541,0.56541,93.7153,495.69)">
                <path class="line" d="M634.087,300.805L673.361,261.53" fill="none" />
              </g>
              <g transform="matrix(2.27612,0,0,2.27612,-792.339,-404.147)">
                <circle class="dot" cx="621.52" cy="316.126" r="1.318" />
              </g>
            </g>
          </svg>
        </div>
      </div>
  
      <div fxLayout="row" fxFlex.xs="100" fxFlex.gt-xs="25" fxLayoutAlign="center center"></div>
    </div>
  </div>
  
  <!-- TITLE -->
  <div fxLayout="row" fxLayoutAlign="center center">
    <h1 mat-dialog-title>{{ alertData.alertTitle }}</h1>
  </div>
  
  <!-- MESSAGE -->
  <div fxLayout="row" fxLayoutAlign="center center">
    <p class="alert-Message" [innerHTML]="alertData.alertMessage"></p>
  </div>
  
  <!-- BUTTONS (dynamic actions if passed) -->
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px" *ngIf="alertData.actions?.length">
    <button
      *ngFor="let btn of alertData.actions"
      mat-flat-button
      [ngStyle]="{
        'background-color': btn.text === 'Ok' ? '#F59120' : '#6C747E',
        'color': '#fff'
      }"
      (click)="onAction(btn.action)">
      {{ btn.text }}
    </button>
  </div>
  
  
  
  
  <!-- Default OK Button -->
  <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!alertData.actions?.length">
    <button mat-flat-button
            [color]="alertData.alertType === 'SUCCESS' ? 'primary' : 'warn'"
            (click)="onAction('close')"
            cdkFocusInitial>
      Ok
    </button>
    
  </div>
  